import React, { PropsWithChildren } from 'react';
import { connect } from 'react-redux';
import { PhotoPrintsPdpState } from '@ff-scene-plugins/photo-prints-redux/store';
import { PhotoPrintsJson } from '@ff-scene-plugins/photo-prints-shared/PhotoPrintsJson';
import { selectPhotoStatusById, selectQuantityById } from '../../../_redux-photos';
import { PhotoPrintFrame } from '../../photo-print/PhotoPrintFrame';
import styles from './PhotoPrintPreviewMobile.module.scss';

const _PhotoPrintPreviewMobile = ({ id, quantity, status, onClick, children }: Props) => (

    <div onClick={onClick} className={styles.container}>

        <PhotoPrintFrame photoId={id} disabled>
            {children}
        </PhotoPrintFrame>

        {status !== 'error' && (
            <div className={styles.quantity}>
                {quantity}
            </div>
        )}
    </div>
);

type OwnProps = PropsWithChildren<{
    id: string;
    onClick?: () => void;
}>;

type Props = OwnProps & {
    quantity: number;
    status: PhotoPrintsJson.ProcessedPhoto['status'];
};

const mapStateToProps = (state: PhotoPrintsPdpState, ownProps: OwnProps) => ({
    quantity: selectQuantityById(state, ownProps.id),
    status: selectPhotoStatusById(state, ownProps.id)!
});

export const PhotoPrintPreviewMobile = connect(
    mapStateToProps
)(_PhotoPrintPreviewMobile);